import FeedLayout from "layouts/files/FeedLayout";
import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { RootState } from "services/redux/store";
import { Button, PasswordInput, SVG } from "ui";
import { isStrongPassword } from "validator";

const ChangePswd = () => {
    // const mode = useSelector((state: RootState) => state.site.mode);

    // pswd
    const [oldPswd, setOldPswd] = useState("");
    // const [oldPswdErr, setOldPswdErr] = useState("");

    const [pswd, setPswd] = useState("");
    const [pswdErr, setPswdErr] = useState("");
    useEffect(() => {
        if (isStrongPassword(pswd)) {
            setPswdErr("");
        } else {
            setPswdErr(
                "Password must be at least 8 characters and contains 1 lowercase letter, 1 uppercase letter, 1 number and 1 symbol"
            );
        }
    }, [pswd]);

    const [cPswd, setCPswd] = useState("");
    const [cPswdErr, setCPswdErr] = useState("");
    useEffect(() => {
        if (pswd !== cPswd) {
            setCPswdErr("Passwords must match!");
        } else {
            setCPswdErr("");
        }
    }, [cPswd]);

    //---------------------------------- saving data
    const handleChangePswd = () => {
        // customToaster("success", "Password changes succefully", mode);
        console.log("clicked");
    };

    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page account-info-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings/account">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Change password</h1>
                    <div></div>
                </div>

                <div className="community-info community-info-fields card">
                    {/* old passwword */}
                    <PasswordInput
                        value={oldPswd}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setOldPswd(e.target.value)}
                        label="Current Password"
                        error={""}
                    />

                    {/* new pswd */}
                    <PasswordInput
                        value={pswd}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setPswd(e.target.value)}
                        label="Password"
                        error={pswdErr}
                    />
                    {/* confirm new pswd */}
                    <PasswordInput
                        value={cPswd}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setCPswd(e.target.value)}
                        label="Confirm Password"
                        error={cPswdErr}
                    />

                    <div className="d-flex flex-j-center flex-a-center w-full">
                        <Button
                            text="change"
                            rounded
                            handleClick={handleChangePswd}
                        />
                    </div>
                </div>
            </div>
        </FeedLayout>
    );
};

export default ChangePswd;
